<template>
  <div class="d-flex flex-lg-row flex-column p-3" style="justify-content: space-around;">
      <router-link aria-label="Página Inicial" to="/" class="img"><img src="../assets/logo.png" alt="logo" class="w-100 my-auto"></router-link>
      <div class="d-flex flex-column gap-sm">
      <h5>Contato</h5>

      <div aria-label="WhatsApp Primeseg" class="d-flex flex-row link btnWpp" @click="irParaWpp()" style="gap:5px;align-items: center;"
          rel="noopener noreferrer">
          <i class="fa-brands fa-whatsapp iconWpp"></i>
          <span>(33) 99733-8463</span>
        </div>
      <a aria-label="Telefone Primeseg" href="tel:+553336413038" class="d-flex flex-row link" style="gap:5px;align-items: center;"
          rel="noopener noreferrer">
          <i class="fa-sharp fa-solid fa-phone"></i>
          <span>(33) 3641-3038</span>
        </a>
        <a aria-label="Email Primeseg" href="mailto:contato@clinicaprimeseg.com.br" class="d-flex flex-row link" style="gap:5px;align-items: center;"
          rel="noopener noreferrer">
          <i class="fa-solid fa-envelope"></i>
            <span>contato@clinicaprimeseg.com.br</span>
        </a>
        <div class="d-flex link" style="gap:5px">
          <i class="fa-sharp fa-solid fa-house"></i>
          <p>Rua Engenheiro Antunes, 8, Sala A <br/>Centro, Teófilo Otoni / MG <br/>39.800-019<br/>CNPJ: 49.645.182/0001-47</p>
        </div>

    </div>
    <!-- <div class="d-flex flex-column gap-md">
      <h4>NewsLetter</h4>
      <div class="d-flex flex-column gap-sm">
        <h6>Fique por dentro de todas <br/> as novidades !</h6>
      <form class="d-flex flex-row form-news">
          <input placeholder="email@email.com" class="w-75" type="email" required>
          <button class="btn btn-sm btn-outline-dark w-25">Assinar</button>
      </form>
      </div>
    </div> -->
  </div>
</template>
<script>

export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  methods: {
    irParaWpp () {
      window.open('https://wa.me/5533997338463?text=Olá gostaria de um orçamento para minha empresa!', '_blank')
    }
  }
}
</script>
<style scoped>
.iconWpp{
  transform: scale(1.1);
}
.btnWpp{
  cursor: pointer;
}
a{
  text-decoration: none;
  color: var(--cor-secondaria);
}
.active{
    color: rgb(0, 0, 0) !important;
 }
h5{
  text-align: left;
}
.form-news{
  padding: 1px;
  border: 1px solid black;
  border-radius: 7px;
}
.form-news > input {
  background: none !important ;
}
.nav-item {
  text-decoration: none;
  cursor: pointer;
  transition: all ease 0.5s !important;
  font-size: 16px;
  text-align: left;
  margin: 0;
  padding: 0;
  color: grey;
}

.nav-item:hover {
  color: var(--cor-primaria) !important;
}
.img{
  width: 25% !important;
}

@media screen and (max-width: 1200px) {

  h5{
    display: none !important;
  }
  .nav-item{
    text-align: center !important;
  }
  .link{
    text-align: center !important;
    margin: 0 auto;
  }
  .img{
    margin: 0 auto 20px auto;
    width: 75% !important;
  }
}

  </style>



// WEBPACK FOOTER //
// src/components/Footer.vue